import React from 'react';

export default () => (
    <span>
        <span className="hidden-xs-down">YEAR</span> TO STUD
    </span>
);



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/HeaderYearToStud.js